/*
 * @Author: zhengxiaowen
 * @Date: 2018-09-25 16:42:20
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-12-01 10:43:28
 */

let _type = process.env.NODE_ENV !== 'production' ? 'local' : 'prod'

let _baseUrl = window.location.protocol + "//" + window.location.hostname + (!!!window.location.port ? "" : ":" + window.location.port)
let _webSocketUrl = "ws://" + window.location.hostname + (!!!window.location.port ? "" : ":" + window.location.port)
if (window.location.protocol.indexOf('https') > -1) {
    _webSocketUrl = "wss://" + window.location.hostname + (!!!window.location.port ? "" : ":" + window.location.port)
}
let platform = {}

switch (_type) {
  case 'local':
    platform.root = 'http://10.10.66.30:8984'
      platform.showImageHost = 'http://10.10.66.30:8982'
      platform.webSocketHost = 'http://10.10.66.30:9020'
      platform.nettyHost = 'ws://10.10.66.30:9010'
    break
  default:
    platform.root = _baseUrl
      platform.nettyHost = _webSocketUrl
    break
}

platform.type = _type
platform.host = platform.root + '/api'
platform.url = {
    zuulBaseServer: platform.host + "/zuul/baseServer",
    baseServer: platform.host + "/baseServer",
    scheduleServer: platform.host + "/schedule",
    exportServer: platform.host + "/exportServer",
    messageServer: platform.host + "/messageServer",
    bpmServer: platform.host + "/bpmServer",
    ruleEngineServer: platform.host + "/ruleEngineServer",
    fileServer: platform.host + "/fileServer",
    webSocketServer: platform.webSocketHost + "/srm-ws",
    srmServer: platform.host + "/srmServer",
    nettyServer: platform.nettyHost + "/ws/netty",

    /*连接本地服务器在此处添加链接*/
    // baseServer: "http://127.0.0.1:9002",
    // fileServer: "http://127.0.0.1:9003",
    //srmServer: "http://127.0.0.1:19020",
    //scheduleServer: "http://127.0.0.1:19006",
    // nettyServer: "ws://127.0.0.1:9010/ws/netty",

}

platform.systemCode = 'MOBILE'
platform.systemName = "SAAF移动系统"
// 设置是否启用复杂密码
platform.complexityPwd = true

export default platform



// WEBPACK FOOTER //
// ./src/config/platform.js